import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const api = axios.create({
  baseURL: API_URL + '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    // 403 BEZ tokena = polumrtva sesija (UI izgleda prijavljen iz cachea, ali API odbija
    // sve pozive jer Authorization header nedostaje) → čisti login umjesto tihe smrti.
    // 403 SA tokenom ne diramo (legitimna permission greška, npr. stats gate).
    if (err.response?.status === 403 && !localStorage.getItem('token')) {
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
